module.exports = __webpack_public_path__ + "img/send_icon_yellow_light.eb7435a7.svg";